$(function() {
  document.querySelectorAll('.payment-item, .address-item').forEach(parent => {
    if (parent.querySelector('input[type=radio]') != null) {
      parent.querySelector('input[type=radio]').addEventListener('change', el => {
        parent
          .closest('.payment-list, .address-list')
          .querySelectorAll('.payment-item, .address-item')
          .forEach(el2 => {
            el2.classList.remove('active')
          })
        if (el.currentTarget.checked) {
          parent.classList.add('active')
        } else {
          parent.classList.remove('active')
        }

        if (parent.dataset.isAddressItem == 'true') {
          var contact_no    = parent.dataset.contactNoAddressHash
          var fully_address = parent.dataset.fullyAddressHash

          document.querySelector('#contact-no-address-hash').textContent = contact_no
          document.querySelector('#fully-address-hash').textContent = fully_address
        }

        if (parent.dataset.isPaymentMethod == 'true') {
          var payment_method_name = parent.dataset.paymentMethodName
          var payment_method_icon = parent.dataset.paymentMethodIcon
          var paymentGateway      = parent.dataset.paymentGateway

          var creditCardForm = document.querySelector('#credit-card-form')
          var inputCardForm  = document.querySelector('#input-credit-card')

          if (paymentGateway != undefined) {
            if (paymentGateway == 'Moneris') {
              if (creditCardForm != null) {
                creditCardForm.classList.remove('d-none')
              }
            } else {
              if (creditCardForm != null) {
                creditCardForm.classList.add('d-none')
              }

              if (inputCardForm != null) {
                inputCardForm.innerHTML = ''
              }
            }
          } else {
            if (creditCardForm != null) {
              creditCardForm.classList.add('d-none')
            }

            if (inputCardForm != null) {
              inputCardForm.innerHTML = ''
            }
          }

          document.querySelector('#payment-method-name').textContent = payment_method_name
          if (document.querySelector('#payment-method-icon') != null) {
            document.querySelector('#payment-method-icon').setAttribute('class', payment_method_icon)
          }
        }
      })
    }
  })
})
